import { render, staticRenderFns } from "./WhatIfsTable.vue?vue&type=template&id=3595d462&"
import script from "./WhatIfsTable.vue?vue&type=script&lang=js&"
export * from "./WhatIfsTable.vue?vue&type=script&lang=js&"
import style0 from "./WhatIfsTable.vue?vue&type=style&index=0&id=3595d462&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports